export const ADD_CHOICE = "ADD_CHOICE";
export const REMOVE_CHOICE = "REMOVE_CHOICE";
export const SET_CHOICE_QUANTITY = "SET_CHOICE_QUANTITY";

export const ADD_DISABLED = "ADD_DISABLED";
export const REMOVE_DISABLED = "REMOVE_DISABLED";
export const ADD_MULTIPLE_DISABLED = "ADD_MULTIPLE_DISABLED";
export const REMOVE_MULTIPLE_DISABLED = "REMOVE_MULTIPLE_DISABLED";

export const ADD_HIDDEN = "ADD_HIDDEN";
export const REMOVE_HIDDEN = "REMOVE_HIDDEN";

export const ADD_PACKAGED = "ADD_PACKAGED";
export const REMOVE_PACKAGED = "REMOVE_PACKAGED";

export type ChoiceActionTypes =
  | typeof ADD_CHOICE
  | typeof REMOVE_CHOICE
  | typeof SET_CHOICE_QUANTITY;
export type DisabledActionTypes =
  | typeof ADD_DISABLED
  | typeof REMOVE_DISABLED
  | typeof ADD_MULTIPLE_DISABLED
  | typeof REMOVE_MULTIPLE_DISABLED;
export type HiddenActionTypes = typeof ADD_HIDDEN | typeof REMOVE_HIDDEN;
export type PackagedActionTypes = typeof ADD_PACKAGED | typeof REMOVE_PACKAGED;

export type AllActionTypes =
  | ChoiceActionTypes
  | DisabledActionTypes
  | HiddenActionTypes
  | PackagedActionTypes;
